var map = {
	"./img-1.png": 71104,
	"./img-10.png": 37104,
	"./img-2.png": 91126,
	"./img-3.png": 29810,
	"./img-4.png": 69751,
	"./img-5.png": 34018,
	"./img-6.png": 92590,
	"./img-7.png": 85206,
	"./img-8.png": 57554,
	"./img-9.png": 60144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84173;